<template lang="pug">
    .banner
        .banner.is-full.image-full(
            :class="{ hover: mouseover }"
            v-if="imageAlignment === 'full'"
        )
            img(v-lazy="image")
            router-link(
                v-if="path"
                :to="path"
                @mouseover.native="hover"
                @mouseleave.native="blur"
            )
            a(
                v-else-if="href"
                :href="href"
                :title="banner.title || banner.sub_title"
                :target="target"
                @mouseover="hover"
                @mouseleave="blur"
            )
        .banner.image-right(v-else-if="imageAlignment === 'right'")
            .columns
                router-link(
                    v-if="path"
                    :to="path"
                    @mouseover.native="hover"
                    @mouseleave.native="blur"
                )

                a(
                    v-else-if="href"
                    :href="href"
                    :title="banner.title || banner.sub_title"
                    :target="target"
                    @mouseover="hover"
                    @mouseleave="blur"
                )
                    .content.column.is-half
                        h4(v-if="banner.sub_title") {{ banner.sub_title }}
                        h2(v-if="banner.title") {{ banner.title }}
                        p.content-text(v-if="banner.text" v-html="banner.text")
                .content.column.is-half(v-else)
                    h4(v-if="banner.sub_title") {{ banner.sub_title }}
                    h2(v-if="banner.title") {{ banner.title }}
                    p.content-text(v-if="banner.text" v-html="banner.text")
                Background.column.is-half(:imageAlignment="imageAlignment" :image="image")
        .banner.image-left(v-else)
            .columns
                Background.column.is-half(:imageAlignment="imageAlignment" :image="image")
                router-link(
                    v-if="path"
                    :to="path"
                    @mouseover.native="hover"
                    @mouseleave.native="blur"
                )
                    .content.column.is-half
                        h4(v-if="banner.sub_title") {{ banner.sub_title }}
                        h2(v-if="banner.title") {{ banner.title }}
                        p.content-text(v-if="banner.text" v-html="banner.text")
                a(
                    v-else-if="href"
                    :href="href"
                    :title="banner.title || banner.sub_title"
                    :target="target"
                    @mouseover="hover"
                    @mouseleave="blur"
                )
                    .content.is-pulled-right
                        h4(v-if="banner.sub_title") {{ banner.sub_title }}
                        h2(v-if="banner.title") {{ banner.title }}
                        p.content-text(v-if="banner.text" v-html="banner.text")
                .content.is-pulled-right(v-else)
                    h4(v-if="banner.sub_title") {{ banner.sub_title }}
                    h2(v-if="banner.title") {{ banner.title }}
                    p.content-text(v-if="banner.text" v-html="banner.text")
</template>

<script>

import _ from 'lodash'
import Background from './BackgroundImage'

export default {
    name: 'Banner',
    components: {
        Background
    },
    data() {
        return {
            delay: 150,
            mouseover: false,
        }
    },
    props: {
        banner: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
        imageAlignment: {
            type: String,
            required: false,
        },
    },
    computed: {
        image() {
            const image = _.get(this.banner, 'images.0')
            if (! image) return false

            const storageRoute = _.trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`, '/')

            let fit = _.get(image, 'pivot.fit') || 'fit=crop&crop=focalpoint&x=.5&y=.5&z=1'
            const parameters = {
                ... _.get(fit.match(/w=(?<w>[0-9]+\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/h=(?<h>[0-9]+\.?[0-9]*)/), 'groups'),
            }
            let { w, h } = parameters

            if (w && h) {
                const aspectRatio = 16 / 10

                h = 320
                w = h * aspectRatio
                fit = fit.replace(/w=([0-9]+\.?[0-9]*)/, `w=${w}`).replace(/h=([0-9]+\.?[0-9]*)/, `h=${h}`)
            } else if (! w && ! h) {
                h = 320
                fit += `&h=${h}`
            }

            return {
                src: `${storageRoute}/images/${image.id}/${image.name}?${fit}`,
                error: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=greyscale`,
                loading: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=blur`,
            }
        },
        href() {
            let href = false

            if (this.banner.link_type !== 'internal' && _.get(this.banner, 'link')) {
                const link = this.banner.link
                switch (this.banner.link_type) {
                    case 'external':
                        if (! _.startsWith(link, 'http://') && ! _.startsWith(link, 'http://')) href = `https://${link}`
                        else href = link
                        break;

                    case 'mailto':
                        href = `mailto:${link}`
                        break;

                    case 'tel':
                        href = `tel:${link}`
                        break;
                }
            }

            return href
        },
        target() {
            return _.get(this.banner, 'link_target') || '_self'
        },
        path() {
            if (this.banner.link_type === 'internal' && _.get(this.banner, 'menuItem.path')) return this.banner.menuItem.path
            else return false
        },
    },
    methods: {
        hover() {
            this.$emit('focus', this.item)
            this.mouseover = true
        },
        blur() {
            setTimeout(() => {
                this.$emit('blur', this.item)
                this.mouseover = false
            }, this.delay);
        },
    },
}
</script>

<style lang="sass" scoped>

    @import "~bulma/sass/utilities/mixins";
    @import '~@/assets/sass/variables';
    .columns
        // margin: 0
    .column
        padding: 0
    .banner
        position: relative
        overflow: hidden
        width: 100%
        &.image-full
            // .content
            //     height: 100vh
            img
                width: 100%
                height: auto
        &.image-left
            .columns
                box-shadow: $box-shadow-3
                background-color: #9db9ca
                margin-bottom: 40px!important
            +mobile
                .background
                    width: 100%
                    background-size: 350px
                    background-repeat: no-repeat
                .content
                    width: 100%
        &.image-right
            .columns
                box-shadow: $box-shadow-3
                background-color: #d8e2e8
                margin-bottom: 40px!important
            +mobile
                .columns
                    display: flex
                    flex-direction: column-reverse
        &.hover
            .background
                transform: scale(1.03)
            .content
                transform: scale(1.06)
        .background
            position: absolute
            background-size: cover
            background-position: center center
            transition: transform .8s ease
            transform-origin: 30% 70% 0
            width: 100%
            height: 100%
            z-index: 1
        .content
            min-height: 420px
            padding: 35px 35px 0
            transition: transform .8s ease
            &:not(:last-child)
                margin-bottom: 0
            +mobile
                padding-top: 15px
            h2, h4
                color: #3b578a
                margin: 0
                padding: 0
                margin-bottom: 15px
            h4
                text-transform: uppercase
                font-size: .85rem
            h2
                margin-top: 10px
                font-size: 2.6rem
                font-weight: 300
            /deep/ p.content-text /** TODO: deep Ersetzen**/
                ul
                    list-style: none
                li:before
                    content: '✓ '
</style>
<style>

@media screen and (min-width: 1024px){
  .section.banners .banners .banner.row .banner .columns {
    max-width: 960px;
    margin: 0 auto;
  }
}

@media screen and (min-width: 1216px){
  .section.banners .banners .banner.row .banner .columns {
    max-width: 1152px;
    margin: 0 auto;
  }
}

@media screen and (min-width: 1408px){
  .section.banners .banners .banner.row .banner .columns {
    max-width: 1344px;
    margin: 0 auto;
  }
}





</style>
